import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export enum NotificationStatus {
    // TODO: Why are they two initial states active and unseen ??? should we remove active ????
    active = "017ca0e9-ece4-4ce9-b3e7-32afccd5e1bf",
    deleted = "a8566e60-b2b7-4b64-b9f1-56e9471124c2",
    seen = "73f5c234-d893-4772-8099-e24305434f4c",
    unseen = "28d0affb-5938-4828-a464-4c5789059ce5",
}

export enum NotificationType {
    btlActivity = "e8a1b2c3-4d5e-4f6a-8b7c-9d0e1f2a3b4c",
    event = "9a49609a-1da9-4d4b-a9d9-2ee6d8e17583",
    eventContainer = "f6c0e559-08dd-45b9-91b3-cdb32c1a21b7",
    target = "a0c3d4e5-6f7a-4b8c-9d0e-1f2a3b4c5d6e",
    /** Ticket resolved (and related ticketing) notifications. */
    ticket = "7c4e1a92-6b3d-4f58-a1c0-9e2d8b7a6c51",
    userInvites = "f9b2c3d4-5e6f-4a7b-9c8d-0e1f2a3b4c5d",
}

export type Notification = {
    additionalData: Record<string, unknown>;
    content: string;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    header: string;
    id: Uuid;
    status: NotificationStatus;
    type: NotificationType;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    userId: Uuid;
    workspaceId: Uuid;
};

export const notificationValidator: zod.ZodType<Notification> = zod.object({
    additionalData: zod.record(zod.string(), zod.unknown()).default({}),
    content: zod.string().trim().min(1),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    header: zod.string().trim().min(1),
    id: uuidZodValidator,
    status: zod.enum(NotificationStatus),
    type: zod.enum(NotificationType),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    userId: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
